import { styled } from "@mui/material";

export const StyledCollapseContainer = styled("div", {
  shouldForwardProp: (prop: string) =>
    prop !== "$isLoading" && prop !== "$isTransparent",
})<{ $isLoading?: boolean; $isTransparent?: boolean }>`
  padding: ${({ theme }) => theme.wsc.spacing[2]}
    ${({ theme }) => theme.wsc.spacing[2]};
  border-radius: ${({ theme }) => theme.wsc.radius.m};
  background-color: ${({ theme, $isTransparent }) =>
    $isTransparent ? "transparent" : theme.wsc.palette.neutral[800]};
  ${({ $isLoading }) =>
    $isLoading &&
    `
    pointer-events: none;
    opacity: 0.5;
  `}
  .collapse-container {
    padding: ${({ theme }) => theme.wsc.spacing[2]} 0 0 0;
  }

  .expanded {
    padding: ${({ theme }) => theme.wsc.spacing[2]};
    background: ${({ theme }) => theme.wsc.palette.neutral[700]};
  }
`;

export const StyledContent = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "$isVisible",
})<{ $isVisible: boolean }>`
  display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
  flex-wrap: wrap;
  flex-direction: column;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  ${({ $isVisible, theme }) => {
    if ($isVisible) {
      return `
      padding-top: ${theme.wsc.spacing[1]};
      border-top: 1px solid ${theme.wsc.palette.neutral[500]};
      margin-top: ${theme.wsc.spacing[1]};
      `;
    }
  }}
`;

export const StyledTitle = styled("div")`
  ${({ theme }) => theme.wsc.typography.body1bold};
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;

  & > :first-child {
    margin-right: ${({ theme }) => theme.wsc.spacing[0]};
  }
`;

export const StyledTitleContainer = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "$isDisabled",
})<{ $isDisabled?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
`;
